module.exports = __webpack_public_path__ + "static/media/dashboard_dark.0596cdc6.svg";